<template>
  <ul class="flex flex-col gap-xs">
    <li class="flex gap-xs items-center">
      <Icon
        name="iad-icon:check-circle-green"
        class="inline-block size-8"
      />
      {{ $t(`alert.key_points.argument_1`) }}
    </li>
    <li class="flex gap-xs items-center">
      <Icon
        name="iad-icon:check-circle-green"
        class="inline-block size-8"
      />
      {{ $t(`alert.key_points.argument_2`) }}
    </li>
    <li class="flex gap-xs items-center">
      <Icon
        name="iad-icon:check-circle-green"
        class="inline-block size-8"
      />
      {{ $t(`alert.key_points.argument_3`) }}
    </li>
  </ul>
</template>
